export function SAVE_MESSAGE_ID(state, [message_id]) {
    state.message_id = message_id
}

export function SAVE_BADGE_ID(state, [badge_id]) {
    state.badge_id = badge_id
}

export function SAVE_NEWS_ID(state, [news_id]) {
    state.news_id = news_id
}